/** Metadatos de administración de un catálogo: tabla, columnas, tipo y dependencias. */
export interface CatalogAdmin {
    /** Identificador del catálogo. */
    id:                          number;
    /** Nombre del catálogo. */
    catalog_name:                string;
    /** Nombre de la llave primaria. */
    primary_key_name:            string;
    /** Nombre de la tabla del catálogo. */
    catalog_table_name:          string;
    /** Nombre de las columnas. */
    columns_name:                string;
    /** Etiqueta de las columnas. */
    columns_name_label:          string;
    /** Tipo de catálogo. */
    catalog_type:                number;
    /** Indica si tiene dependencia (puede ser nulo). */
    dependence:                  boolean | null;
    /** Identificador del catálogo del que depende (puede ser nulo). */
    catalog_dependence_id:       number | null;
    /** Nombre de la columna llave de dependencia (puede ser nulo). */
    dependence_column_name_key:  null | string;
    /** Tabla intermedia del catálogo (puede ser nula). */
    catalog_middle_table:        null | string;
    /** Columna de la tabla intermedia (puede ser nula). */
    catalog_middle_table_column: null | string;
    /** Llave de relación con el padre (puede ser nula). */
    relation_parent_key:         null | string;
    /** Estatus del catálogo. */
    status:                      null;
}

/** Datos para registrar un ítem dentro de un catálogo. */
export interface CatalogPost {
    /** Identificador del catálogo destino. */
    catalog_id:   number;
    /** Datos del ítem a registrar. */
    data_catalog: DataCatalog;
}

/** Datos de un ítem de catálogo, con campos flexibles según el catálogo. */
export interface DataCatalog {
    /** Identificador del ítem. */
    id?:                  number;
    /** Descripción del ítem. */
    description?:         string;
    /** Descripción en inglés (puede ser nula). */
    description_english?: string | null;
    /** Descripción corta (puede ser nula). */
    short_description?:   string | null;
    /** Identificador en SAP (puede ser nulo). */
    sap_id?:              string | null;
    /** Identificador del grupo de material (puede ser nulo). */
    material_group_id?:   number | null;
    /** Identificador del cliente (puede ser nulo). */
    id_customer?:         number | null;
    /** Identificador de la razón social (puede ser nulo). */
    id_business_name?:    number | null;
    /** País (puede ser nulo). */
    country?:             string | null;
    /** Nombre (puede ser nulo). */
    name?:                string | null;
    /** Población (puede ser nula). */
    population?:          string | null;
    /** Código postal (puede ser nulo). */
    postal_code?:         string | null;
    /** Región (puede ser nula). */
    region?:              string | null;
    /** Domicilio (puede ser nulo). */
    address?:             string | null;
}

/** Respuesta del registro de un ítem de catálogo. */
export interface CatalogPostResponse {
    /** Identificador del ítem creado. */
    id:     number;
    /** Indica si la operación produjo error. */
    error:  boolean;
}

/** Razón social de un cliente con datos de domicilio. */
export interface BusinessName {
  /** Identificador de la razón social. */
  id_business_name: number;
  /** País. */
  country:          string;
  /** Nombre de la razón social. */
  name:             string;
  /** Población. */
  population:       string;
  /** Código postal. */
  postal_code:      string;
  /** Región. */
  region:           string;
  /** Domicilio. */
  address:          string;
}
